import { motion } from "framer-motion";

export const ArrowRosette = ({ className = "w-full h-auto" }) => (
  <img src="/jvf-symbol.png" alt="Símbolo JVF" className={className} />
);

export const AnimatedRosette = ({ className = "w-64 lg:w-[26rem]" }) => (
  <motion.div
    className={className}
    initial={{ rotate: -120, scale: 1.5, opacity: 0 }}
    animate={{ rotate: 0, scale: 1, opacity: 1 }}
    transition={{ duration: 1.5, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
    data-testid="hero-rosette"
  >
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
      className="text-white"
    >
      <ArrowRosette />
    </motion.div>
  </motion.div>
);

export const JVFLogo = () => (
  <a href="/#top" data-testid="logo-link" className="flex items-center gap-3 text-white">
    <ArrowRosette className="h-9 w-9" />
    <span className="h-9 w-px bg-white/40" aria-hidden="true" />
    <span className="leading-none">
      <span className="block font-oswald text-2xl font-bold tracking-tight">JVF</span>
      <span className="block text-[9px] font-light uppercase tracking-[0.35em] text-white/70">
        Despachos
      </span>
    </span>
  </a>
);
